// The agreed announcement timezone is fixed EST (UTC-5), including Nov 1.
export const NOVEL_NOVEMBER_GATE = "novelNovember2026";
export const NOVEL_NOVEMBER_START = "2026-11-01T00:00:00-05:00";
export const NOVEL_NOVEMBER_END = "2026-12-01T00:00:00-05:00";
export const NOVEL_NOVEMBER_WINDOWS = [
  [1, 6], [4, 13], [7, 20], [10, 6], [13, 13], [16, 20],
  [19, 6], [22, 13], [25, 20], [28, 6], [30, 13],
].map(([day, hour]) => {
  const start = `2026-11-${String(day).padStart(2, "0")}T${String(hour).padStart(2, "0")}:00:00-05:00`;
  return { id: `nov-${day}`, start, end: new Date(Date.parse(start) + 3 * 3600000).toISOString(), enabled: true };
});
export const defaultSprintConfig = () => ({
  revision: 0, enabled: false, maxConcurrent: null,
  windows: NOVEL_NOVEMBER_WINDOWS.map(window => ({ ...window })), manual: null,
});
export function activeSprintWindow(config, now = Date.now()) {
  if (!config?.enabled || !Number.isInteger(config.maxConcurrent) || config.maxConcurrent < 1 ||
      now < Date.parse(NOVEL_NOVEMBER_START) || now >= Date.parse(NOVEL_NOVEMBER_END)) return null;
  return [config.manual, ...(config.windows || [])].find(window =>
    window && window.enabled !== false && Date.parse(window.start) <= now && now < Date.parse(window.end)) || null;
}
export function sprintAccountEligible(subscription) {
  // Enrollment funds an otherwise permitted request; it does not reactivate a
  // lapsed membership or grant a missing tool entitlement.
  return subscription?.features?.[NOVEL_NOVEMBER_GATE] === true && !subscription.deletedAt &&
    !subscription.lapsed() && subscription.allowAIFunctions(false, false, null, { requireCredits: false });
}
export function sprintToolAccess(subscription) {
  return {
    write: true,
    draft: subscription.hasAccessToStoryEngine === true && subscription.hasAccessToStoryEngineProseGenerate === true,
  };
}
// Exact request targets: body fields cannot turn unrelated AI functions free.
export function sprintRequestKind(req) {
  if (req.method !== "POST" || req.body?.benchmarkMode === true) return null;
  const path = req.originalUrl.split("?")[0];
  const match = path.match(/^\/api\/ai\/runDynamicPluginAction\/(documentPlugins\/write(?:Claude3)?\/(?:auto|guided)\/excellent)$/);
  if (match && (!req.body?.pluginId || req.body.pluginId === match[1])) return "write";
  const draftRequests = {
    "/api/ai/storyEngine/write/chapterGenerator": "draft",
    "/api/ai/storyEngine/write/estimateChapter": "estimate",
    "/api/ai/storyEngine/write/analyze-scenes": "analysis",
    "/api/ai/storyEngine/write/rewrite-scenes": "rewrite",
  };
  if (req.body?.scenesEngine === "ballad-1.1-draft") return draftRequests[path] || null;
  return null;
}
